require('../../modules/es6.math.cbrt');
module.exports = require('../../modules/$.core').Math.cbrt;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/math/cbrt.js
// module id = 214
// module chunks = 0